import React from "react";
import { FormGroup, Input, Label } from "reactstrap";

interface IInputTextProp {
    value: string,
    type: any,
    label: string,
    name: string,
    placeholder?: string,
    rows?: number,
    id?: string,
    step?: number,
    onChange?: (e:any)=>void,
    error?: any,
    className?: string
    controlIcon?: any,
    showRequired?: boolean
}

interface IInputTextState {
  isTouched: boolean
}

class InputText extends React.Component<IInputTextProp, IInputTextState> {

    state = {
        isTouched: false
    }
  
    componentDidMount = () => {
      this.setState({isTouched: false})
    }

    onChange = (e:any) => {
      if(this.props.onChange)
        this.props.onChange(e);
      this.setState({isTouched: true});
    }

    render() {
      const { isTouched } = this.state;
      const className = this.props.className || '';
      const { controlIcon } = this.props;
      const showRequired = this.props.showRequired || false;
    return (
      <React.Fragment>
        <Label htmlFor="name">{this.props.label} { showRequired && <span className="primary">*</span>}</Label>
        <FormGroup className="position-relative">
            <Input
                type={this.props.type || 'text'}
                step={this.props.step}
                value={this.props.value}
                name={this.props.name}
                rows={this.props.rows || 0}
                placeholder={this.props.placeholder || ''}
                className={`form-control ${this.props.error && isTouched && "is-invalid"} ${className}` }
                onChange={this.onChange}
                id={this.props.id}
        />
        {
          controlIcon && 
          <div className="form-control-position">
            {controlIcon}
          </div>
        }
        {this.props.error && isTouched && <div className="invalid-tooltip mt-25">{this.props.error}</div>}
      </FormGroup>
      </React.Fragment>
    );
  }
}
export default InputText;
